import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmationConfig {
  content: string;
  action: string;
  cancel?: string;
  subtitle?: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmationDialogComponent {
  content: string;
  cancel: string;
  action: string;
  subtitle: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationConfig,
  ) {
    this.content = data.content;
    this.action = data.action;
    this.cancel = data.cancel || 'BUTTONS.CANCEL';
    this.subtitle = data.subtitle || '';
  }
}
